export default "/images/vendor/flag-icons/flags/1x1/tj.svg?a089dcba40ab020ac75e224f8ef712f6";